/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateMobileListingPaymentRequest} from '@cash-web/protos/squareup/cash/cashbusinesspayments/api/v1beta1/listing.pb'
import {CreateMobileListingPaymentResponse} from '@cash-web/protos/squareup/cash/cashbusinesspayments/api/v1beta1/listing.pb'


export const createMobileListingPayment = (request: CreateMobileListingPaymentRequest, options?: CashRequestOptions) => post<CreateMobileListingPaymentRequest, CreateMobileListingPaymentResponse>("/2.0/cash/create-mobile-listing-payment", request, {...options, rejectOnError: true })